
export const clientVersion = "2.1.2";

export const clientInfoVersion = "2.1.2-HF1.Sha.bffbe548d7f4f86a227fc93f150181148ff73002";

